import React, { useEffect, useState } from 'react'
import PosMenu from '../componentes/pos/PosMenu'
import PosBody from '../componentes/pos/PosBody'
import axios from 'axios'
import Cookies from 'universal-cookie'
import moment from 'moment'
import { useNavigate } from 'react-router-dom';
import { jsonrepair } from 'jsonrepair'

const Pos = () => {
    //almacena toda la data de mediodePagos 
    const [mediosDePago, setMediosDePago] = useState([])
    const [pedidosAntiguos, setPedidosAntiguos] = useState([])
    const [cierres, setCierres] = useState([{ fecha: '' }])
    const [estadoCierre, setEstadoCierre] = useState()
    const baseUrl = process.env.REACT_APP_BASE_URL
    const api = process.env.REACT_APP_API

    const urlPedidos = baseUrl + api + 'pedidos/'
    const urlMedios = baseUrl + api + 'mediosdepago/'
    const urlCierres = baseUrl + api + 'cierresdecaja/'
    const UrlUbicaciones = baseUrl + api + 'zonasdeenvio/'
    const UrlDomiciliarios = baseUrl + api + 'domiciliarios/'
    const urAtributos = baseUrl + api + 'atributos/'
    const urlConfiguraciones = baseUrl + api + 'configuraciones/'
    const rutaCargas = baseUrl + api + 'cargas/'
    const rutaReglasEnvio = baseUrl + api + 'reglasdeenvio/'
    const rutaCupones = baseUrl + api + 'cupones/'
    const cookies = new Cookies()
    const navigate = useNavigate();
    const [finalFecha, setFinalFecha] = useState(new Date());
    const [buscador, setBuscador] = useState(false)
    const [codigoBarras, setCodigoBarras] = useState(false)
    const urlProductosPos = baseUrl + api + 'productos/productospos.php'

    const [vistaMovil, setVistaMovil] = useState('ver')

    const [intervalMs, setIntervalMs] = useState(10000)
    const [estadoInventario, setEstadoInventario] = useState({ inventarioMinimo: 0, totalProductos: 0 })

    const peticionTraeEstadoInventario = async () => {
        try {
            const { data } = await axios.get(urlProductosPos, {
                params: { inventory_status: 'true' }
            })
            setEstadoInventario(data || { inventarioMinimo: 0, totalProductos: 0 })
        } catch (error) {
            console.log(error)
        }
    }


    const cambiarBuscador = () => setBuscador(!buscador)
    const cambiarCodigoBarras = () => setCodigoBarras(!codigoBarras)

    const irAdmin = e => {
        navigate("/admin");
    }

    const peticionTraeDatos = () => {
        

        //let inicioFechaFormat = moment(startDate).format("YYYY-MM-DD")
        let diaAyer = moment(finalFecha).subtract(1, 'days').format("YYYY-MM-DD")
        let finalFechaFormat = moment(finalFecha).format("YYYY-MM-DD")

        axios.get(urlPedidos, { params: { tipo: 'avanzada', date: diaAyer, date2: finalFechaFormat } })
            .then(response => {
                let respuesta = []
                respuesta = response.data
                let newArr = []
                respuesta.map((item) => {
                    newArr.push({
                        ...item,
                        datosPago: JSON.parse(jsonrepair(item.datosPago)),
                        pedido: item.pedido.length > 0 ? JSON.parse(jsonrepair(item.pedido)) : '',
                        pedido: JSON.parse(jsonrepair(item.pedido)),
                        cliente: JSON.parse(jsonrepair(item.cliente))
                    })
                })
                setPedidosAntiguos(newArr)
            })

        axios.get(urlMedios)
            .then(response => {
                let respuestaMedios = response.data

                const items = []
                respuestaMedios.map(medio => {
                    items.push({ value: medio.id.toString(), label: medio.nombre, tarifa: parseFloat(medio.tarifa), id: medio.id })
                })
                // guardamos la data de la peticion para mostrarla en la tabla
                setMediosDePago(items)
            })

    }

    const peticionTraeCierres = () => {
        axios.get(urlCierres)
            .then(response => {
                let respuesta = response.data
                setCierres(respuesta)
            })
    }

    const cerrarSesion = e => {
        cookies.remove('id', { path: "/" })
        cookies.remove('nombre', { path: "/" })
        cookies.remove('usuario', { path: "/" })
        cookies.remove('sede', { path: "/" })
        cookies.remove('roll', { path: "/" })
        navigate("/");
    }

    //Trae todas las mediodePagos de la api
    useEffect(() => {
        peticionTraeDatos()
        //peticionTraeMedios()
        peticionTraeCierres()
        peticionTraeEstadoInventario()
    }, [])

    useEffect(() => {
        const intervalId = setInterval(() => {
            peticionTraeEstadoInventario()
        }, intervalMs)

        return () => clearInterval(intervalId)
    }, [intervalMs])


    useEffect(() => {
        if (!cookies.get('usuario')) {
            //history.push("/")
            navigate("/")
        }

    }, [])

    const revisaCierre = () => {

        //busca el ultimo registro de tipo Z y devuelve su fecha
        //por default toma el día de ayer para cuando no hayan cierres Z
        //por default la caja esté abierta
        let fechaEncontrada = moment().subtract(1, 'days');
        let result = ''
        for (let i = 0; i < cierres.length; i++) {
            if (cierres[i].tipo === 'Z' || cierres[i].tipo === 'A') {
                if (cierres[i].tipo === 'Z') {
                    fechaEncontrada = cierres[i].fecha;
                    break;
                }
                if (cierres[i].tipo === 'A') {
                    result = 'A'
                    break;
                }
            }
        }

        if (result === 'A') {
            setEstadoCierre('abierto')
        } else {
            let fechaFormat = moment(fechaEncontrada).format("DD-MM-YYYY")

            let hoy = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
            //let hoy = moment("2020-12-22")
            let momentA = moment(hoy, "DD/MM/YYYY");
            let momentB = moment(fechaFormat, "DD/MM/YYYY");

            if (momentA > momentB) {
                //console.log('mayor - abierta')
                setEstadoCierre('abierto')
            }
            else if (momentA < momentB) {
                //console.log('menor - cerrado')
                setEstadoCierre('cerrado')
            }
            else {
                //console.log('iguales - cerrado')
                setEstadoCierre('cerrado')
            }
        }
    }

    useEffect(() => {
        revisaCierre()
    }, [cierres])

    return (
        <>
            <PosMenu
                irAdmin={irAdmin}
                cerrarSesion={cerrarSesion}
                cierre={estadoCierre}
                cambiarBuscador={cambiarBuscador}
                cambiarCodigoBarras={cambiarCodigoBarras}
                estadoInventario={estadoInventario}
                vistaMovil={vistaMovil}
                setVistaMovil={setVistaMovil}
            />
            <PosBody
                vistaMovil={vistaMovil}
                setVistaMovil={setVistaMovil}
                buscador={buscador}
                rutaCargas={rutaCargas}
                rutaReglasEnvio={rutaReglasEnvio}
                baseUrl={baseUrl + api}
                mediosDePago={mediosDePago}
                rutaCupones={rutaCupones}
                pedidosAntiguos={pedidosAntiguos}
                setPedidosAntiguos={setPedidosAntiguos}
                cierre={estadoCierre}
                UrlUbicaciones={UrlUbicaciones}
                UrlDomiciliarios={UrlDomiciliarios}
                urlConfiguraciones={urlConfiguraciones}
                urAtributos={urAtributos}
                codigoBarras={codigoBarras}
                cambiarCodigoBarras={cambiarCodigoBarras}
                urlProductosPos={urlProductosPos}
            />
        </>
    )
}

export default Pos
